export default __webpack_public_path__ + "static/media/infoIcon.66df3e0b.svg";